import Input from '@mui/material/Input';
import Stack from '@mui/material/Stack';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, FormControl, MenuItem, Select, TextField } from '@mui/material';
import RichTextEditor from '../RichTextEditor';
import { useState } from 'react';
import { GTranslate } from '@mui/icons-material';

function TranslationInputField(props) {
    const { translation, label, field, value, description, name, handleInputChange, type, config } = props;
    const [translationValue, setTranslationValue] = useState(value);
    const [expanded, setExpanded] = useState(false);
    console.log('props', props);

    // TODO use lazy loading
    // TODO move languages to state
    const languages = [{ "code": "en-US" }, { "code": "fr-FR" }];

    const onChange = (field, value) => {
        setTranslationValue(value);

        handleInputChange(field, value);
    }

    return (
        <Stack>
            <Typography className="form-label" variant='label'>{label}</Typography>

            <Stack
                direction={'row'}
                spacing={1}
                alignItems={'center'}
            >
                {
                    config?.fieldType === 'textarea' &&
                    <RichTextEditor
                        value=""
                    />
                }

                {
                    (config?.fieldType !== 'textarea' || !config?.fieldType) &&
                    <Input
                        inputProps={{
                            className: 'form-input'
                        }}
                        sx={{
                            color: '#262626 !important',
                            py: 0,
                            width: '100%'
                        }}
                        type="text"
                        value={translationValue}
                        onChange={(event) => { onChange(field, event.target.value) }}
                        placeholder=""
                        variant="standard"
                    />
                }
                
                <a
                    onClick={() => { setExpanded(!expanded) }}
                >
                    <Typography
                        variant={'span'}
                    >
                        <GTranslate />
                    </Typography>
                </a>
            </Stack>

            <Box
                sx={{
                    border: '1px solid #e0e0e0',
                    borderRadius: '5px',
                    p: 2,
                    mt: 2,
                    display: expanded ? 'block' : 'none',
                }}
            >
                <Typography
                    variant={'label'}
                    sx={{
                        textTransform: 'uppercase',
                    }}
                >
                    Other Languages
                </Typography>
                <Stack
                    direction={'row'}
                    spacing={1}
                    alignItems={'center'}
                >
                    <FormControl
                        sx={{
                            flexGrow: 1
                        }}
                    >
                        {
                            (config?.fieldType !== 'textarea' || !config?.fieldType) &&
                            <TextField
                                multiline={type === 'textarea'}
                                inputProps={{
                                    className: 'form-input'
                                }}
                                sx={{
                                    color: '#262626 !important',
                                    py: 0,
                                    width: '100%'
                                }}
                                value={""}
                                placeholder=""
                                variant="standard"
                            />
                        }

                        {
                            config?.fieldType === 'textarea' &&
                            <RichTextEditor
                                value=""
                            />

                        }
                    </FormControl>

                    <FormControl
                        sx={{
                            width: '5rem'
                        }}
                    >
                        <Select
                            inputProps={{
                                className: 'form-input'
                            }}
                            sx={{
                                borderRadius: 0,
                                '& .MuiSelect-select': {
                                    borderRadius: 0
                                }
                            }}
                        >
                            {
                                languages.map(language => (
                                    <MenuItem
                                        key={language.code}
                                        sx={{
                                            textTransform: 'uppercase'
                                        }}
                                        value={language}
                                    >
                                        {language.code}
                                    </MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                </Stack>
            </Box>

            <Typography
                className="form-input-description"
                variant='p'
            >
                {description}
            </Typography>
        </Stack>
    )
}

export default TranslationInputField